import React, {createContext, useContext, useMemo, useState} from 'react'

import {PlannerForecastType, type PlannerForecastTypeValue} from '../consts'

interface SelectedForecastTypeState {
  selectedForecastType: PlannerForecastTypeValue
  setSelectedForecastType: (forecastType: PlannerForecastTypeValue) => void
}

const SelectedForecastTypeContext = createContext<SelectedForecastTypeState | undefined>(undefined)

export const useSelectedForecastType = () => {
  const context = useContext(SelectedForecastTypeContext)
  if (!context) {
    throw new Error('useSelectedForecastType must be used within a SelectedForecastTypeProvider')
  }
  return context
}

export const SelectedForecastTypeProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [selectedForecastType, setSelectedForecastType] = useState<PlannerForecastTypeValue>(
    PlannerForecastType.StatisticalForecast
  )

  const memoizedState = useMemo(
    () => ({
      selectedForecastType,
      setSelectedForecastType
    }),
    [selectedForecastType, setSelectedForecastType]
  )

  return (
    <SelectedForecastTypeContext.Provider value={memoizedState}>
      {children}
    </SelectedForecastTypeContext.Provider>
  )
}
